
import { Vue, Options } from "vue-property-decorator";
@Options({
  name: "time-icon-svg",
})
export default class TimeIconSvg extends Vue {}
